import * as React from 'react';
import { HeaderFilterTable } from '@/components/common';
import { Options } from '@/components/ui/combobox';
import { GET_CLIENT_DIRECTORY_ACTION_FILTER } from '@/api';
import { useQuery } from '@tanstack/react-query';
import { clientDirectoryService } from '@/api/clientDirectory';
import { useFilters } from '@/hooks';
import { getIcon, getNameFormatted } from '../../client-directory/filters';
import { useRouter } from 'next/router';

interface ActionRequiredTasksFilterProps {
	title: string;
}

export const ActionRequiredTasksFilter: React.FC<
	ActionRequiredTasksFilterProps
> = ({ title }) => {
	const router = useRouter();
	const filterKey = 'actionStatusLawyer';
	const { actionStatusLawyer } = router.query;
	const { setParamFilter, hasFilter } = useFilters();
	const [data, setData] = React.useState<Options[]>([]);

	const { data: actionFilterList } = useQuery({
		queryKey: [GET_CLIENT_DIRECTORY_ACTION_FILTER],
		queryFn: () => clientDirectoryService.getActionFilter(),
	});

	React.useEffect(() => {
		if (actionFilterList) {
			const auxList: Options[] = [];
			actionFilterList.data.map((item) =>
				auxList.push({
					label: getNameFormatted(item),
					value: item,
					icon: getIcon(item),
				})
			);
			auxList.push({
				label: getNameFormatted('PENDING'),
				value: 'PENDING',
				icon: getIcon('PENDING'),
			});
			setData(auxList);
		}
	}, [actionFilterList]);

	const handleSelectFilters = (value?: string) => {
		setParamFilter(filterKey, value);
	};

	const handleClearAll = () => {
		setParamFilter(filterKey, '');
	};

	return (
		<>
			<HeaderFilterTable
				title={title}
				searchTitle="Tasks"
				filterOptions={data}
				handleClearAll={handleClearAll}
				handleSelectFilters={handleSelectFilters}
				hasFilter={hasFilter(filterKey)}
				classNamePopoverContent="sm:!w-[237px]"
				placeholder="View All"
				buttonContentDefault={true}
				value={actionStatusLawyer as string}
			/>
		</>
	);
};
